import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 500,
      fontSize: '0.875rem',
      backgroundColor: palette.background.underBox,
      borderRadius: palette.borderRadius.default,
      padding: '7.5px 10px 7.5px 10px',
      display: 'flex',
      flexDirection: (props: { isDesktop: boolean }) =>
        props.isDesktop ? 'row' : 'column',
      gap: '10px',
      alignItems: (props: { isDesktop: boolean }) =>
        props.isDesktop ? 'center' : 'stretch',
      width: '100%',
      marginBottom: (props: { isDesktop: boolean }) =>
        props.isDesktop ? '0' : '10px',
      '& select': {
        userSelect: 'none'
      }
    },
    radioItem: {
      borderRadius: '5px',
      '& > label': {
        display: 'flex',
        padding: '5px',
        gap: '5px',
        background: palette.background.box,
        borderRadius: '5px'
      },
      '&:has(input[type="radio"]:checked)': {
        border: `2px solid ${palette.common.black}`
      },
      '& > input[type="radio"]': {
        display: 'none'
      }
    },
    numSquare: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: '21px',
      padding: '0 3px',
      height: '21px',
      borderRadius: '5px',
      color: palette.common.white
    },
    gray: {
      background: palette.background.dark
    },
    red: {
      background: palette.common.red
    },
    blue: {
      background: palette.common.primaryBlue
    },
    green: {
      background: palette.common.green,
      color: palette.common.black
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
